export interface FormatItemTimeOptions {
  loggedMinutes: number
  estimatedHours?: number | null
  actualMinutes?: number | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t?: (key: any, args?: any) => string
}

export interface FormatItemTimeResult {
  text: string
  loggedText: string
  approvedText: string | null
  estimateText: string | null
  isOverEstimate: boolean
  tone: 'warning' | 'neutral'
  className: string
}

export function formatMinutesToHoursAndMinutes(totalMinutes: number): string {
  const mins = Math.max(0, Math.round(totalMinutes))
  const h = Math.floor(mins / 60)
  const m = mins % 60
  if (h === 0 && m === 0) return '0m'
  if (h === 0) return `${m}m`
  if (m === 0) return `${h}h`
  return `${h}h ${m}m`
}

export function formatItemTimeLoggedAndEstimate({
  loggedMinutes,
  estimatedHours,
  actualMinutes,
  t,
}: FormatItemTimeOptions): FormatItemTimeResult {
  const loggedText = formatMinutesToHoursAndMinutes(loggedMinutes)
  const hasEstimate =
    typeof estimatedHours === 'number' &&
    !isNaN(estimatedHours) &&
    estimatedHours > 0
  const estimateMinutes = hasEstimate ? (estimatedHours as number) * 60 : null

  const hasApproved =
    typeof actualMinutes === 'number' &&
    !isNaN(actualMinutes) &&
    actualMinutes >= 0

  const approvedText = hasApproved
    ? formatMinutesToHoursAndMinutes(actualMinutes)
    : null
  const estimateText = hasEstimate ? `${estimatedHours}h` : null

  const isOverEstimate = Boolean(
    hasEstimate &&
      estimateMinutes !== null &&
      ((hasApproved && (actualMinutes as number) > estimateMinutes) ||
        loggedMinutes > estimateMinutes),
  )
  const tone: 'warning' | 'neutral' = isOverEstimate ? 'warning' : 'neutral'

  let text: string
  if (hasApproved) {
    if (hasEstimate) {
      text = `Logged ${loggedText} · Approved ${approvedText} · Est ${estimateText}`
    } else {
      text = `Logged ${loggedText} · Approved ${approvedText}`
    }
  } else if (hasEstimate) {
    if (t) {
      text = t('NLSTimesheetsItemLoggedWithEstimate', {
        logged: loggedText,
        estimate: estimateText,
      })
    } else {
      text = `Logged ${loggedText} / Est ${estimateText}`
    }
  } else {
    if (t) {
      text = t('NLSTimesheetsItemLoggedOnly', {
        logged: loggedText,
      })
    } else {
      text = `Logged ${loggedText}`
    }
  }

  const className = `itemTimeLoggedEstimate ${isOverEstimate ? 'isOverEstimate' : ''}`.trim()

  return {
    text,
    loggedText,
    approvedText,
    estimateText,
    isOverEstimate,
    tone,
    className,
  }
}
